function initButtons(): void {
  document
    .querySelectorAll<HTMLElement>(
      ".btn:has(svg):not(.btn--animated)",
    )
    .forEach((btn) => {
      const svg = btn.querySelector("svg");
      if (!svg) return;

      const exitWrap = document.createElement("span");
      exitWrap.className = "btn__icon-wrap btn__icon-wrap--exit";
      svg.replaceWith(exitWrap);
      exitWrap.appendChild(svg);

      const entryWrap = exitWrap.cloneNode(true) as HTMLElement;
      entryWrap.className = "btn__icon-wrap btn__icon-wrap--entry";
      entryWrap.setAttribute("aria-hidden", "true");
      btn.prepend(entryWrap);

      btn.classList.add("btn--animated");
    });
}

document.addEventListener("DOMContentLoaded", initButtons);
document.addEventListener("htmx:load", initButtons);
